import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { getText } from "../../../../utils/util";
import "./index.css";

export default function SettingPage({ userInfo }) {
  const navigate = useNavigate();
  const { t: translate } = useTranslation();
  return (
    <div className="min-h-screen bg-neutral-900 px-4 py-6">
      <div className="max-w-lg mx-auto">
        {/* 用户信息区域 */}
        <div className="bg-neutral-800 rounded-xl mb-6">
          <div className="p-4 space-y-4">
            {/* 昵称 */}
            <div className="flex flex-col space-y-1">
              <div className="text-neutral-400 text-sm">
                <p>{translate(getText("暱稱"))}</p>
              </div>
              <div className="flex items-center justify-between">
                <p className="text-white">{userInfo?.userCode}</p>
                <div className="flex items-center">
                  <div className="w-px h-4 bg-neutral-700 mr-2"></div>
                  <svg
                    className="w-5 h-5 text-neutral-400"
                    viewBox="0 0 20 20"
                    fill="currentColor"
                  >
                    <path
                      fillRule="evenodd"
                      d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
                      clipRule="evenodd"
                    />
                  </svg>
                </div>
              </div>
            </div>

            {/* 账号 */}
            <div className="flex flex-col space-y-1">
              <div className="text-neutral-400 text-sm">
                <p>{translate(getText("賬號"))}</p>
              </div>
              <div className="flex items-center justify-between">
                <p className="text-white">{userInfo?.username}</p>
                <div className="flex items-center">
                  <div className="w-px h-4 bg-neutral-700 mr-2"></div>
                  <svg
                    className="w-5 h-5 text-neutral-400"
                    viewBox="0 0 20 20"
                    fill="currentColor"
                  >
                    <path
                      fillRule="evenodd"
                      d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
                      clipRule="evenodd"
                    />
                  </svg>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* 功能设置区域 */}
        <div className="bg-neutral-800 rounded-xl mb-6">
          <div className="divide-y divide-neutral-700">
            {/* 语言切换 */}
            <div
              className="p-4 flex items-center justify-between cursor-pointer hover:bg-neutral-700 transition-colors duration-200"
              onClick={() => navigate("/changelanguage")}
            >
              <div className="text-white">
                <p>{translate(getText("語言切換"))}</p>
              </div>
              <div className="flex items-center">
                <div className="w-px h-4 bg-neutral-700 mr-2"></div>
                <svg
                  className="w-5 h-5 text-neutral-400"
                  viewBox="0 0 20 20"
                  fill="currentColor"
                >
                  <path
                    fillRule="evenodd"
                    d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
                    clipRule="evenodd"
                  />
                </svg>
              </div>
            </div>

            {/* 线路切换 */}
            <div
              className="p-4 flex items-center justify-between cursor-pointer hover:bg-neutral-700 transition-colors duration-200"
              onClick={() => navigate("/changeline")}
            >
              <div className="text-white">
                <p>{translate(getText("切換線路"))}</p>
              </div>
              <div className="flex items-center">
                <div className="w-px h-4 bg-neutral-700 mr-2"></div>
                <svg
                  className="w-5 h-5 text-neutral-400"
                  viewBox="0 0 20 20"
                  fill="currentColor"
                >
                  <path
                    fillRule="evenodd"
                    d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
                    clipRule="evenodd"
                  />
                </svg>
              </div>
            </div>
          </div>
        </div>

        {/* 退出登录按钮 */}
        <div className="px-4">
          <button
            onClick={() => {
              localStorage.removeItem("uid");
              localStorage.removeItem("username");
              localStorage.removeItem("x-access-token");
              localStorage.removeItem("userCode");
              navigate("/login");
            }}
            className="w-full bg-gradient-primary text-white py-4 rounded-lg font-medium
                     hover:opacity-90 active:opacity-80 transition-opacity duration-200
                     shadow-card focus:outline-none focus:ring-2 focus:ring-primary focus:ring-opacity-50"
          >
            {translate(getText("退出登錄"))}
          </button>
        </div>
      </div>
    </div>
  );
}
